import reduceReducers from "reduce-reducers";

import { BUSINESS, SIDELOADED_BUSINESS } from "constants/actionTypes";

import {
  bulkUpdateCases,
  defaultInitialState,
  offlineCrudReducer,
} from "lib/reducers";
import { deserializeSideLoadedBusiness } from "lib/serializers/sideLoadedBusinesses";

const crudReducer = offlineCrudReducer(SIDELOADED_BUSINESS, {
  deserializer: deserializeSideLoadedBusiness,
});

const initialState = { ...defaultInitialState };

const bulkSetIgnoredReducer = (state = initialState, action) => {
  switch (action.type) {
    // The request carries an entry per record, so the grid reflects the change
    // before the response; the response carries only the records it changed.
    case SIDELOADED_BUSINESS.BULK_SET_IGNORED.REQUEST:
    case SIDELOADED_BUSINESS.BULK_SET_IGNORED.SUCCESS:
      return bulkUpdateCases(
        state,
        action,
        "byId",
        deserializeSideLoadedBusiness,
      );

    case SIDELOADED_BUSINESS.BULK_SET_IGNORED.FAILURE: {
      const { ids, isIgnored } = action;
      return {
        ...state,
        byId: ids.reduce(
          (byId, id) =>
            byId[id]
              ? {
                  ...byId,
                  [id]: { ...byId[id], isIgnored: !isIgnored, syncing: false },
                }
              : byId,
          { ...state.byId },
        ),
      };
    }

    default:
      return state;
  }
};

// The save response doesn't include linked records, so mirror the server here.
const businessSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case BUSINESS.CREATE.REQUEST:
    case BUSINESS.UPDATE.REQUEST: {
      const { id: businessId, side_loaded_data_ids: recordIds } =
        action.payload || {};
      if (!recordIds?.length) {
        return state;
      }
      const byId = { ...state.byId };
      recordIds.forEach(recordId => {
        const record = byId[recordId];
        if (record && !record.businessIds.includes(businessId)) {
          byId[recordId] = {
            ...record,
            businessIds: [...record.businessIds, businessId],
            isIgnored: false,
          };
        }
      });
      return { ...state, byId };
    }

    default:
      return state;
  }
};

const sideLoadedBusinesses = reduceReducers(
  initialState,
  crudReducer,
  bulkSetIgnoredReducer,
  businessSaveReducer,
);

export default sideLoadedBusinesses;
